import { links } from "data";
import { ExternalLink } from "shared/components";
import { AccordionContainer } from "./accordion-container";
import styles from "./accordions.module.scss";

export const ABOUT_ACCORDION_KEY = "ABOUT_ACCORDION_KEY";

export const AboutAccordion = () => {
  return (
    <AccordionContainer accordionKey={ABOUT_ACCORDION_KEY}>
      <div className="flex gap-sm">
        <div className="flex flex-column gap-xs">
          <span className={styles.subtitle}>About CitySprint</span>
          <ExternalLink href={links.NATIONAL_COVERAGE}>
            National coverage
          </ExternalLink>
          <ExternalLink href={links.OUR_CUSTOMERS}>Our customers</ExternalLink>
          <ExternalLink href={links.ABOUT_US}>Who we are</ExternalLink>
          <ExternalLink href={links.OUR_PEOPLE}>Our people</ExternalLink>
          <ExternalLink href={links.OUR_FLEET}>Our fleet</ExternalLink>
        </div>
        <div className="flex flex-column gap-xs">
          <span className={styles.subtitle}>Helping you grow</span>
          <ExternalLink href={links.CASE_STUDIES}>Case studies</ExternalLink>
          <ExternalLink href={links.TESTIMONIALS}>Testimonials</ExternalLink>
          <ExternalLink href={links.AWARDS}>Awards</ExternalLink>
          <ExternalLink href={links.TECHNOLOGY}>Technology</ExternalLink>
          <ExternalLink href={links.SELL_YOUR_BUSINESS}>
            Selling your business?
          </ExternalLink>
        </div>
        <div className="flex flex-column gap-xs">
          <span className={styles.subtitle}>Building a better future</span>
          <ExternalLink href={links.CSR_FOCUS}>CSR Focus</ExternalLink>
          <ExternalLink href={links.SUSTAINABLE_DELIVERY}>
            Sustainable delivery
          </ExternalLink>
          <ExternalLink href={links.SUPPORTING_LOCAL_COMMUNITIES}>
            Supporting local communities
          </ExternalLink>
          <ExternalLink href={links.EMPOWERING_OUR_PEOPLE}>
            Empowering our people
          </ExternalLink>
          <ExternalLink href={links.BACKING_BUSINESS}>
            Backing business
          </ExternalLink>
        </div>
        <div className={styles.separator} />
        <div className="flex flex-column gap-xs">
          <span className={styles.subtitle}>Work with us</span>
          <ExternalLink href={links.CAREERS}>Careers</ExternalLink>
          <ExternalLink href={links.BECOME_A_COURIER}>
            Become a courier
          </ExternalLink>
        </div>
      </div>
    </AccordionContainer>
  );
};
